export default "__VITE_ASSET__B3Tz_Tvu__"